module.exports = __webpack_public_path__ + "img/IMG_0447.30cdc7ce.png";